import { render, staticRenderFns } from "./screen2.vue?vue&type=template&id=749329bd&scoped=true&"
import script from "./screen2.vue?vue&type=script&lang=js&"
export * from "./screen2.vue?vue&type=script&lang=js&"
import style0 from "./screen2.vue?vue&type=style&index=0&id=749329bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749329bd",
  null
  
)

export default component.exports